<script>
  // Перенос passField из src_ui/web/src/screens/Auth.tsx — дословно (та же разметка).
  export let label = '';
  export let value = '';
  export let toggle = false;
  export let showPass = false;
  export let onEnter = () => {};
  export let onToggle = () => {};
  export let onInput = () => {};
</script>

<div class="fld">
  <div class="labelrow">
    <label>{label}</label>
    {#if toggle}
      <div class="labelact" on:click={onToggle}>{showPass ? 'скрыть' : 'показать'}</div>
    {/if}
  </div>
  {#if toggle && showPass}
    <input
      type="text"
      {value}
      placeholder="••••••••"
      autocomplete="off"
      on:input={(e) => onInput(e.target.value)}
      on:keydown={(e) => e.key === 'Enter' && onEnter()}
    />
  {:else}
    <input
      type="password"
      {value}
      placeholder="••••••••"
      autocomplete="off"
      on:input={(e) => onInput(e.target.value)}
      on:keydown={(e) => e.key === 'Enter' && onEnter()}
    />
  {/if}
</div>
